import React, { useEffect } from "react";

const MultiPolygonMap = ({ polygons, defLat, defLng }) => {
  useEffect(() => {
    const L = window.L;
  
    const map = L.map("multi-map").setView([defLat, defLng], 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);

    polygons.forEach(({ coordinates, description }) => {
      const latLngs = coordinates.map(([lng, lat]) => [lat, lng]);
      const polygon = L.polygon(latLngs, { color: "blue", fillOpacity: 0.4 }).addTo(map);
      polygon.bindPopup(description);
    });

    return () => {
      map.remove();
    };
  }, [polygons, defLat, defLng]);

  return <div id="multi-map" style={{ height: "600px" }}></div>;
};

export default MultiPolygonMap;
